import { useState } from "react";
import {
  ModalContainer,
  ModalContent,
  TitleContainer,
  ModalTitle,
  CloseButton,
  Description,
  InputContainer,
  Label,
  Input,
} from "./PublishOnFapifyModal.styles";
import { ReactComponent as CloseSvg } from "../../assets/icons/close.svg";
import Modal from "../utils/Modal/Modal";
import Button from "../utils/Button/Button";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import { toast } from "../modern-ui/sonner";
import { useDispatch, useSelector } from "react-redux";
import { publishOnFapify } from "../../store/slices/model/asyncThunks";
import { selectPublishOnFapifyPending } from "../../store/slices/model/slice";

const PublishOnFapifyModal = ({ isOpen, onClose, trainModelId }) => {
  useLockBodyScroll(isOpen);
  const dispatch = useDispatch();
  const loading = useSelector(selectPublishOnFapifyPending);
  const [fapifyUsername, setFapifyUsername] = useState("");

  const handleConfirm = () => {
    if (!fapifyUsername.trim()) {
      toast.error("Please enter your Fapify username");
      return;
    }
    if (!trainModelId) return;

    dispatch(
      publishOnFapify({
        trainModelId,
        fapifyUsername: fapifyUsername.trim(),
      }),
    )
      .unwrap()
      .then((result) => {
        toast.success(result.message);
        onClose();
      })
      .catch((err) => {
        toast.error(err?.message || "Failed to publish on Fapify");
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      onAfterClose={() => {
        setFapifyUsername("");
      }}
    >
      <ModalContainer>
        <ModalContent>
          <TitleContainer>
            <ModalTitle>Publish on Fapify</ModalTitle>
            <CloseButton onClick={onClose}>
              <CloseSvg />
            </CloseButton>
          </TitleContainer>

          <Description>
            You must have an account on Fapify to publish your template. Enter
            your Fapify username below to continue.
          </Description>

          <InputContainer>
            <Label>Fapify Username</Label>
            <Input
              type="text"
              placeholder="Enter your Fapify username"
              value={fapifyUsername}
              onChange={(e) => setFapifyUsername(e.target.value)}
            />
          </InputContainer>

          <Button
            onClick={handleConfirm}
            disabled={loading || !fapifyUsername.trim()}
            title="Publish"
            loading={loading}
            style={{ width: "100%" }}
          />
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default PublishOnFapifyModal;
